// extracted by mini-css-extract-plugin
module.exports = {"formBox":"AddPhase_formBox_19Jlb","field":"AddPhase_field_HrMFA","buttonsContainer":"AddPhase_buttonsContainer_296es"};